/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesMemberStatus } from './WebApiModelsEnumerationTypesMemberStatus';
import {
    WebApiModelsEnumerationTypesMemberStatusFromJSON,
    WebApiModelsEnumerationTypesMemberStatusFromJSONTyped,
    WebApiModelsEnumerationTypesMemberStatusToJSON,
} from './WebApiModelsEnumerationTypesMemberStatus';

/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoMemberStatusMismatchDto
 */
export interface WebApiIntegrationsDtoMemberStatusMismatchDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoMemberStatusMismatchDto
     */
    memberId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMemberStatusMismatchDto
     */
    customerNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoMemberStatusMismatchDto
     */
    fullName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiIntegrationsDtoMemberStatusMismatchDto
     */
    oneFrontIsActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiIntegrationsDtoMemberStatusMismatchDto
     */
    externalIsActive?: boolean;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesMemberStatus}
     * @memberof WebApiIntegrationsDtoMemberStatusMismatchDto
     */
    oneFrontStatus?: WebApiModelsEnumerationTypesMemberStatus;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoMemberStatusMismatchDto interface.
 */
export function instanceOfWebApiIntegrationsDtoMemberStatusMismatchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoMemberStatusMismatchDtoFromJSON(json: any): WebApiIntegrationsDtoMemberStatusMismatchDto {
    return WebApiIntegrationsDtoMemberStatusMismatchDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoMemberStatusMismatchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoMemberStatusMismatchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'memberId': !exists(json, 'memberId') ? undefined : json['memberId'],
        'customerNumber': !exists(json, 'customerNumber') ? undefined : json['customerNumber'],
        'fullName': !exists(json, 'fullName') ? undefined : json['fullName'],
        'oneFrontIsActive': !exists(json, 'oneFrontIsActive') ? undefined : json['oneFrontIsActive'],
        'externalIsActive': !exists(json, 'externalIsActive') ? undefined : json['externalIsActive'],
        'oneFrontStatus': !exists(json, 'oneFrontStatus') ? undefined : WebApiModelsEnumerationTypesMemberStatusFromJSON(json['oneFrontStatus']),
    };
}

export function WebApiIntegrationsDtoMemberStatusMismatchDtoToJSON(value?: WebApiIntegrationsDtoMemberStatusMismatchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'memberId': value.memberId,
        'customerNumber': value.customerNumber,
        'fullName': value.fullName,
        'oneFrontIsActive': value.oneFrontIsActive,
        'externalIsActive': value.externalIsActive,
        'oneFrontStatus': WebApiModelsEnumerationTypesMemberStatusToJSON(value.oneFrontStatus),
    };
}

